const Event = require('./lib/event');

global.UserActivity = {
	visibility: true,
	focus: true,

	onUserActivityChanged: Event(),

	init: function(){
		let me = this;

		tabVisibility(function(e){
			me.updateUserStatus();
		});

		$(window).on('focus', function(e){ me.focus = true; me.updateUserStatus(); });
		$(window).on('blur', function(e){ me.focus = false; me.updateUserStatus(); });
	},

	isUserActive: function(){
		return this.visibility && this.focus;
	},

	updateUserStatus: function(){
		this.visibility = tabVisibility();
		this.onUserActivityChanged(this.isUserActive());
	},
};
